import React, { FC } from 'react';
import styles from './Marker.module.scss';
import { AdvancedMarker } from '@vis.gl/react-google-maps';

export interface MarkerProps {
  number: number;
  lat: number;
  lng: number;
}

const Marker: FC<MarkerProps> = ({ number, lat, lng }) => {
  return (
    <AdvancedMarker position={{ lat, lng }}>
      <div className={styles.markerWrapper}>
        <div className={styles.marker}>{number}</div>
      </div>
    </AdvancedMarker>
  );
};

export default Marker;
